import { render, staticRenderFns } from "./SystemMaintenance.vue?vue&type=template&id=66fd0b02"
import script from "./SystemMaintenance.vue?vue&type=script&lang=ts"
export * from "./SystemMaintenance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports